<template>
    <Card dis-hover shadow>
    <div slot="title">
    <Button class="backBtn" type="primary" @click="setBackBtn" >
      返回
    </Button>
    <span class="lidaCard-title">
      网站维护
    </span>
    </div>
    <div>
      <lida-table :propscolumns="ipcolumns" :data="items" :sortStatus="false">
        <template v-slot:headerSelect>
          <Button type="primary"  @click="maintainSet">
        新增维护
      </Button>
      <Select v-model="gameval" style="width:80px" class="maintainSelect">
        <Option v-for="item in gameSelect" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
       <span class="maintainTitle">
        <b> 新增维护歷程記錄</b>
        </span>
        </template>
      </lida-table>
    </div>
</Card>
</template>
<script>
    export default {
      data () {
        return {
          gameval:'0',
          gameSelect:[
            { label: "全部", value: "0" }
          ],
          items: [],
          ipcolumns: {
            indexNumber: {
              title: '序号',
              key: 'indexNumber',
              align: 'center',
            },
            mark: {
              title: '维护站点',
              key: 'mark',
              align: 'center',
              totaltext: '总计',
              notetext: '小计',
            },
            l1tl: {
              title: '维护开始时间',
              key: 'l1tl',
              align: 'center',
            },
            buvalue: {
              title: '维护结束时间',
              key: 'buvalue',
              align: 'center',
            },
            buvalue: {
              title: '维护结束变更时间',
              key: 'buvalue',
              align: 'center',
            },
            buvalue: {
              title: '维护公告内容',
              key: 'buvalue',
              align: 'center',
            },
            buvalue: {
              title: '操作',
              key: 'buvalue',
              align: 'center',
            } 
          }
        }
      },
      methods: {
        maintainSet () {
          this.$router.push({ name: 'site-maintain' })
        },
        setBackBtn () {
            this.$router.go(-1)
        },
      }
    }
</script>
<style>
  .lidaCard-title{
    font-weight: bold;
    padding-bottom: 10px;
  }
  .maintainTitle {
    color: #1d3c78;
    padding-top:12px;
  }
  .maintainAddBtn{
    font-size: 12px;
    padding: 0px 14px 0px 14px;
    height: 28px;
    float: left;
  }
  .maintainAddBtn span{
    padding-top: 4px;
    font-size: 12px;
  }
  .maintainSelect {
    margin-top:2px;
    margin-left: 10px;
  }
</style>